import React from 'react';
import { Link } from 'gatsby';
import Grid from '@material-ui/core/Grid';
import logo from '../assets/logoGrey.svg';
import '../theme/footer.scss';

const CustomFooter = (props): JSX.Element => {

  return (
    <>
      <footer style={{ marginTop: 20, backgroundColor: '#F9F9F9' }}>
        <div className="container-foot">
          <div className="footer-wrap">
            <Link to="/">
              <img
                style={{ marginTop: 40 }}
                alt="logo"
                src={logo}
                height={25}
              />
            </Link>
            <Grid container style={{ marginTop: 35 }}>
              <Grid item xs={12} sm={6} md={3}>
                <b>Secciones</b>
                <ul className="linksVertical">
                    <li>
                        <a href="/comentario-diario-historico">Comentario Diario</a>
                    </li>
                    <li>
                        <a href="/mercados">Apertura</a>
                    </li>
                    <li>
                        <a href="/internacional">Internacional</a>
                    </li>
                    <li>
                        <Link to="/renta-variable">Renta Variable</Link>
                    </li>
                    <li>
                        <Link to="/tecnico">Técnico</Link>
                    </li>
                    <li>
                        <Link to="/economico">Económico</Link>
                    </li>
                    <li>
                        <Link to="/vector-basics">Basics</Link>
                    </li>
                  <li>
                        <Link to="/webinar">Webinar</Link>
                    </li>

                </ul>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <b>Acerca de Nosotros</b>
                <ul className="linksVertical">

                  <li>
                    <a href="https://www.vector.com.mx/quienes-somos/">
                      Quiénes Somos
                    </a>
                  </li>
                  <li>
                    <a href="https://www.vector.com.mx/valor-agregado/">
                      Valor Agregado
                    </a>
                  </li>
                  <li>
                    <Link to="/autores">Autores</Link>
                  </li>
                </ul>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <b>Legal</b>
                <ul className="linksVertical">
                  <li>
                    <a href="https://www.vector.com.mx/terminos-legales/">
                      Términos Legales
                    </a>
                  </li>
                  <li>
                    <a href="https://www.vector.com.mx/aviso-de-privacidad/">
                      Aviso de privacidad
                    </a>
                  </li>
                  <li>
                    <a href="https://www.vector.com.mx/wp-content/uploads/ComunicadoSistRemuneracionAMIB.pdf">
                      Aviso sobre el Sistema de Remuneración
                    </a>
                  </li>
                  <li>
                    <a href="https://www.vector.com.mx/une/">
                      Atención a Cliente Especializada
                    </a>
                  </li>
                  <li>
                    <Link to="/disclosure">Disclosure</Link>
                  </li>
                </ul>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <>
                    <b style={{cursor:"pointer"}} onClick={()=>props.openModal()}>Suscríbete</b>
                </>
              </Grid>

            </Grid>
          </div>
          <div className="pullCenter copyRight">
            Copyright &copy; {new Date().getFullYear()}{' '}
            <a href="https://www.e-vector.com.mx">Vector Casa de Bolsa</a> Todos
            los derechos reservados
          </div>
        </div>
      </footer>
    </>
  );
};

export default CustomFooter;
